import { format, parseISO } from "date-fns"
import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"

import Table from "src/components/Table"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

import TaxCell from "./TaxCell"
import { discountDisplayText, formatDate } from "./helpers"

const ItemDetailsTableRow = ({ item, productSale }) => {
  const { presentmentCurrency } = useMarina()
  const { amount, id, posted_at: postedAt } = item
  const {
    external_sale: isExternalSale,
    name,
    original_amount: originalAmount,
    discount_amount: discountTotal,
    product_sale_discounts: productSaleDiscounts,
    product_sale_taxes: productSaleTaxes,
    quantity,
    service_end_date: serviceEndDate,
    service_start_date: serviceStartDate,
    tax_rate: taxRate,
    tax_amount: taxAmount,
    note,
  } = productSale

  return (
    <Table.Row key={id} variant="parent">
      <Table.Cell title="Sale" />
      <Table.Cell title={name} subtitle={note} />
      <Table.Cell
        title={format(parseISO(postedAt), "MM/dd/yyyy hh:mm:ss aa")}
      />
      <Table.Cell title={formatDate(serviceStartDate)} />
      <Table.Cell title={formatDate(serviceEndDate)} />
      <Table.Cell title={quantity} />
      <Table.Cell title={isExternalSale ? "External sale" : "-"} />
      <Table.Cell
        title={formatCurrencyFromMinorUnits({
          amount: originalAmount,
          currency: presentmentCurrency,
        })}
      />
      <Table.Cell>
        {productSaleDiscounts?.length > 0 &&
          productSaleDiscounts
            .sort((discount) => discount.apply_order)
            .map((discount) => (
              <div className="whitespace-nowrap" key={discount.id}>
                {discountDisplayText({
                  ...discount,
                  currency: presentmentCurrency,
                })}
              </div>
            ))}
      </Table.Cell>
      <Table.Cell
        title={formatCurrencyFromMinorUnits({
          amount: discountTotal,
          currency: presentmentCurrency,
        })}
      />
      <TaxCell
        taxRate={taxRate}
        taxAmount={taxAmount}
        taxes={productSaleTaxes}
        currency={presentmentCurrency}
      />
      <Table.Cell
        title={formatCurrencyFromMinorUnits({
          amount,
          currency: presentmentCurrency,
        })}
      />
    </Table.Row>
  )
}

ItemDetailsTableRow.propTypes = {
  item: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    posted_at: PropTypes.string.isRequired,
  }).isRequired,
  productSale: PropTypes.shape({
    external_sale: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    original_amount: PropTypes.number.isRequired,
    discount_amount: PropTypes.number.isRequired,
    product_sale_discounts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        apply_order: PropTypes.number.isRequired,
        amount: PropTypes.number.isRequired,
      })
    ).isRequired,
    product_sale_taxes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        rate: PropTypes.number.isRequired,
        rate_display: PropTypes.string.isRequired,
      })
    ),
    quantity: PropTypes.string.isRequired,
    service_end_date: PropTypes.string.isRequired,
    service_start_date: PropTypes.string.isRequired,
    tax_amount: PropTypes.number.isRequired,
    tax_rate: PropTypes.string,
    note: PropTypes.string,
  }).isRequired,
}

export default ItemDetailsTableRow
